// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicInformation_container__qfUVT {
  background-color: var(--accent-color);
}

.BasicInformation_basic-information__nI7qY {
  display: flex !important;
  padding: 40px;
  align-items: center;
  align-self: stretch;
  gap: 80px;
}
.BasicInformation_basic-information__left__1su1l {
  height: 100%;
}
.BasicInformation_basic-information__right__LYW05 {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-self: stretch;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_logo-wrapper__vs8uD {
  background-color: white;
  padding: 8px;
  border: 1px solid var(--light-grey);
  border-radius: 8px;
  height: 100%;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_logo-wrapper__vs8uD .BasicInformation_logo__-A\\+eM {
  height: 30vh;
  aspect-ratio: 12/16;
  object-fit: contain;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_name__5dOhJ {
  color: white;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 3px;
  margin: 0;
  line-height: 1.2;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_bio__9yZ5Q {
  color: rgba(255, 255, 255, 0.7);
  text-align: justify;
  font-size: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info__fibSz {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item__1ztaO {
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: white;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  text-transform: initial;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn {
  height: 16px;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn svg {
  width: 16px;
  height: 16px;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn svg path {
  fill: white;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- {
  height: 16px;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- svg {
  width: 16px;
  height: 16px;
}
.BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- svg path {
  stroke: white;
}
@media only screen and (max-width: 480px) {
  .BasicInformation_basic-information__nI7qY {
    flex-direction: column;
    padding: 32px;
    gap: 32px;
  }
  .BasicInformation_basic-information__right__LYW05 {
    gap: 16px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_logo-wrapper__vs8uD {
    padding: 4px;
    border-radius: 4px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_logo-wrapper__vs8uD .BasicInformation_logo__-A\\+eM {
    height: 20vh;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_name__5dOhJ {
    font-size: 24px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_bio__9yZ5Q {
    font-size: 14px;
    -webkit-line-clamp: 4;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item__1ztaO {
    flex: 1 1;
    background-color: var(--accent-color-medium);
    padding: 8px;
    font-size: 12px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn {
    height: 12px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn svg {
    width: 12px;
    height: 12px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--start-icon__Nb0yn svg path {
    fill: white;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- {
    height: 12px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- svg {
    width: 12px;
    height: 12px;
  }
  .BasicInformation_basic-information__nI7qY .BasicInformation_more-info--item--link-icon__d7GX- svg path {
    stroke: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/BasicInformation/BasicInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;;AAEA;EAEE,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAIE;EACE,uBAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;AAFJ;AAII;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AAFN;AAME;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAJJ;AAOE;EACE,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAQE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AANJ;AAQI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AANN;AAQM;EACE,YAAA;AANR;AAQQ;EACE,WAAA;EACA,YAAA;AANV;AAQU;EACE,WAAA;AANZ;AAWM;EACE,YAAA;AATR;AAWQ;EACE,WAAA;EACA,YAAA;AATV;AAWU;EACE,aAAA;AATZ;AAgBE;EApGF;IAqGI,sBAAA;IACA,aAAA;IACA,SAAA;EAbF;EAeE;IACE,SAAA;EAbJ;EAgBE;IACE,YAAA;IACA,kBAAA;EAdJ;EAeI;IACE,YAAA;EAbN;EAiBE;IACE,eAAA;EAfJ;EAkBE;IACE,eAAA;IACA,qBAAA;EAhBJ;EAoBI;IACE,SAAA;IACA,4CAAA;IACA,YAAA;IACA,eAAA;EAlBN;EAmBM;IACE,YAAA;EAjBR;EAmBQ;IACE,WAAA;IACA,YAAA;EAjBV;EAmBU;IACE,WAAA;EAjBZ;EAsBM;IACE,YAAA;EApBR;EAsBQ;IACE,WAAA;IACA,YAAA;EApBV;EAsBU;IACE,aAAA;EApBZ;AACF","sourcesContent":[".container {\n  background-color: var(--accent-color);\n}\n\n.basic-information {\n  // min-height: 40vh;\n  display: flex !important;\n  padding: 40px;\n  align-items: center;\n  align-self: stretch;\n  gap: 80px;\n\n  &__left {\n    height: 100%;\n  }\n\n  &__right {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-self: stretch;\n  }\n\n  .logo-wrapper {\n    background-color: white;\n    padding: 8px;\n    border: 1px solid var(--light-grey);\n    border-radius: 8px;\n    height: 100%;\n\n    .logo {\n      height: 30vh;\n      aspect-ratio: 12/16;\n      object-fit: contain;\n    }\n  }\n\n  .name {\n    color: white;\n    font-size: 40px;\n    font-weight: 700;\n    letter-spacing: 3px;\n    margin: 0;\n    line-height: 1.2;\n  }\n\n  .bio {\n    color: rgba(255, 255, 255, 70%);\n    text-align: justify;\n    font-size: 16px;\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    cursor: pointer;\n  }\n\n  .more-info {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n\n    &--item {\n      padding: 4px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      color: white;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n      text-transform: initial;\n\n      &--start-icon {\n        height: 16px;\n\n        svg {\n          width: 16px;\n          height: 16px;\n\n          path {\n            fill: white;\n          }\n        }\n      }\n\n      &--link-icon {\n        height: 16px;\n\n        svg {\n          width: 16px;\n          height: 16px;\n\n          path {\n            stroke: white;\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    flex-direction: column;\n    padding: 32px;\n    gap: 32px;\n\n    &__right {\n      gap: 16px;\n    }\n\n    .logo-wrapper {\n      padding: 4px;\n      border-radius: 4px;\n      .logo {\n        height: 20vh;\n      }\n    }\n\n    .name {\n      font-size: 24px;\n    }\n\n    .bio {\n      font-size: 14px;\n      -webkit-line-clamp: 4;\n    }\n\n    .more-info {\n      &--item {\n        flex: 1;\n        background-color: var(--accent-color-medium);\n        padding: 8px;\n        font-size: 12px;\n        &--start-icon {\n          height: 12px;\n\n          svg {\n            width: 12px;\n            height: 12px;\n\n            path {\n              fill: white;\n            }\n          }\n        }\n\n        &--link-icon {\n          height: 12px;\n\n          svg {\n            width: 12px;\n            height: 12px;\n\n            path {\n              stroke: white;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BasicInformation_container__qfUVT`,
	"basic-information": `BasicInformation_basic-information__nI7qY`,
	"basic-information__left": `BasicInformation_basic-information__left__1su1l`,
	"basic-information__right": `BasicInformation_basic-information__right__LYW05`,
	"logo-wrapper": `BasicInformation_logo-wrapper__vs8uD`,
	"logo": `BasicInformation_logo__-A+eM`,
	"name": `BasicInformation_name__5dOhJ`,
	"bio": `BasicInformation_bio__9yZ5Q`,
	"more-info": `BasicInformation_more-info__fibSz`,
	"more-info--item": `BasicInformation_more-info--item__1ztaO`,
	"more-info--item--start-icon": `BasicInformation_more-info--item--start-icon__Nb0yn`,
	"more-info--item--link-icon": `BasicInformation_more-info--item--link-icon__d7GX-`
};
export default ___CSS_LOADER_EXPORT___;
